export const defaultSelfManagePace = { min: 1, max: 2 };

export const DEFAULT_DURATION_SECOND = {
  ONE: 1,
  TWO: 2,
  FOUR: 4,
  SIX: 6,
}
